import { request } from './http-client'

const botService = {
  createSession: (chat_id: string) => request.post(`/v1/create-session`, { chat_id }),
}

export default botService
